import { render, staticRenderFns } from "./fccTodosColegios.vue?vue&type=template&id=59cc66a0"
import script from "./fccTodosColegios.vue?vue&type=script&lang=js"
export * from "./fccTodosColegios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports